<div class="notification-container">
    <app-notification-item
      *ngFor="let notification of notifications"
      [style.background-color]="notification?.color"
      [notification]="notification"
      (remove)="removeNotification($event)"
    ></app-notification-item>
  </div>